<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="业务发展情况" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-upload
                    name="file"
                    action="./api/main/hydcgl/hydc/importExcel"
                    :multiple="false"
                    :data="{ id: editData.id }"
                    @change="uploadSafeEvent"
                    :showUploadList="false"
                    :headers="headers"
                    accept=".xls,.xlsx,.csv,.xlsm"
                >
                    <!-- <a-button class="tool-button" type="primary" icon="plus">导入Excel</a-button> -->
                </a-upload>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" style="padding:10px 20px;">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="统一社会信用代码" required>
                                            <a-input ref="tyshxydm" v-model="editData.tyshxydm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位名称">
                                            <a-input ref="xdwmc" v-model="editData.xdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位成立时间" required>
                                            <a-date-picker ref="dwclsj" v-model="editData.dwclsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="法定代表人" required>
                                            <a-input ref="frdb" v-model="editData.frdb" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="注册资本（万元）" required>
                                            <a-input-number ref="zczj" v-model="editData.zczj" style="width:100%" :min="0" :precision="6" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="币种" required>
                                            <a-input ref="bzmc" v-model="editData.bzmc" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人姓名" required>
                                            <a-input ref="lxr" v-model="editData.lxr" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人固定电话" required>
                                            <a-input ref="gddh" v-model="editData.gddh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人手机号" required>
                                            <a-input ref="yddh" v-model="editData.yddh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人电子邮箱" required>
                                            <a-input ref="dzyx" v-model="editData.dzyx" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="备案编号" required>
                                            <a-input ref="babh" v-model="editData.babh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位类型" required>
                                            <FGDictSelectCN dictNo="DW100103" v-model="editData.dwxz" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="是否上市" required>
                                            <FGDictSelectCN dictNo="1101" v-model="editData.sfss" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="营收规模" required>
                                            <FGDictSelectCN dictNo="HY100203" v-model="editData.ysgm" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="其中工程咨询营收规模" required>
                                            <FGDictSelectCN dictNo="HY100203" v-model="editData.gczxysgm" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="通讯地址" required>
                                            <a-input ref="txdz" v-model="editData.txdz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单位网址">
                                            <a-input ref="dwwz" v-model="editData.dwwz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <!-- <a-form-item label="所在城市">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item> -->
                                        <a-form-item label="所在城市" required>
                                            <a-input-search ref="qymc" @search="isShow_qymc = true" v-model="editData.qymc" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_qymc"
                                                selectNo="JC100101T"
                                                condition=" AND PARENT_ID ='BDEAEF16DD9E4603AA2C146F3390E1A4' "
                                                @saveselect="saveEvent_qymc(arguments, editData)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="初次开展工程咨询年份" required>
                                            <!-- <a-date-picker ref="cckzzxsj" v-model="editData.cckzzxsj" valueFormat="YYYY-MM-DD" style="width:100%" /> -->
                                            <FGDictSelectCN ref="cckzzxsj" dictNo="P0002" v-model="editData.cckzzxsj" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程咨询单位资信等级" required>
                                            <FGDictSelectCN dictNo="ZX100102" v-model="editData.zxdj" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="甲级综合资信情况" required>
                                            <FGDictSelectCN dictNo="HY100201" v-model="editData.jjzhzxqk" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="甲级专业资信个数" required>
                                            <a-input-number ref="jjzyzxgs" v-model="editData.jjzyzxgs" :min="0" style="width:100%" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="乙级专业资信个数" required>
                                            <a-input-number ref="yjzyzxgs" v-model="editData.yjzyzxgs" :min="0" style="width:100%" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="PPP咨询专项资信个数" required>
                                            <a-input-number ref="yjzyzxgs" v-model="editData.pppzxzxzxqk" :min="0" style="width:100%" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程勘察资质" required>
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.gckczz" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程设计资质" required>
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.gcsjzz" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="工程监理资质" required>
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.gcjlzz" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="对外承包工程资格" required>
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.dwcbgczg" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="保密资质" required>
                                            <FGDictSelectCN dictNo="HY100202" v-model="editData.bmzz" placeholder="" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="填表人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="填表时间">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea v-model="editData.bz" :rows="3" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 专业类别明细表格 -->
                        <FGCollapsiblePanel title="专业类别明细" v-show="false">
                            <!-- 表格 -->
                            <vxe-toolbar size="mini">
                                <template v-slot:tools>
                                    <a-button type="primary" :loading="saving || loading" @click="insertItem">新增</a-button>
                                </template>
                            </vxe-toolbar>
                            <vxe-table
                                ref="itemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemData"
                                :edit-config="{
                                    trigger: 'click',
                                    mode: 'row',
                                    showStatus: true,
                                    showIcon: false
                                }"
                            >
                                <vxe-table-column type="seq" title="序号" width="120" align="center"></vxe-table-column>
                                <FGDataSelect :isShow.sync="isShow_zymc" selectNo="JC1002" @saveselect="saveEvent_zymc(arguments, editItemData)"></FGDataSelect>
                                <vxe-table-column
                                    field="zymc"
                                    title="业务领域"
                                    header-class-name="required"
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    min-width="200"
                                >
                                    <template v-slot:edit="scope">
                                        <a-input-search size="small" ref="zymc" readOnly @search="search_zymc(scope.row)" v-model="scope.row.zymc" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    field="xms"
                                    title="项目数(个)"
                                    header-class-name="required"
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    width="250"
                                    align="right"
                                >
                                    <template v-slot:edit="scope">
                                        <a-input-number size="small" v-model="scope.row.xms" :min="0" :precision="0" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    field="xmztze"
                                    title="项目总投资额(亿元)"
                                    header-class-name="required"
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    width="250"
                                    align="right"
                                >
                                    <template v-slot:edit="scope">
                                        <a-input-number size="small" v-model="scope.row.xmztze" :min="0" :precision="6" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column title="操作" width="200" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="removeItem(scope.row)">删除</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 人员情况明细表格 -->
                        <FGCollapsiblePanel title="人员情况表">
                            <vxe-table
                                ref="itemTableRYMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataRYMX"
                                :edit-config="{
                                    trigger: 'click',
                                    mode: 'cell',
                                    showStatus: true,
                                    showIcon: false
                                }"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <!-- pre 会保留所有空格，无论多少个 -->
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" width="150" align="center">
                                    <template v-slot="{ row }">
                                        <a-input-number v-if="row.dm === '32'" v-model="row.sl" :min="0" :precision="0" disabled />
                                        <a-input-number v-else v-model="row.sl" :min="0" :precision="0" />
                                    </template>
                                </vxe-table-column>
                                <!-- <vxe-table-column field="djzzysl" title="登记主专业数量" width="200" align="right"></vxe-table-column>
                                <vxe-table-column field="djfzysl" title="登记辅专业数量" width="200" align="right"></vxe-table-column> -->
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位业务情况明细表格 -->
                        <FGCollapsiblePanel title="业务状况表">
                            <vxe-table
                                ref="itemTableYWMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataYWMX"
                                :edit-config="{
                                    trigger: 'click',
                                    mode: 'cell',
                                    showStatus: true,
                                    showIcon: false
                                }"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" width="150" align="center">
                                    <template v-slot="scope">
                                        <a-input-number
                                            v-if="scope.row.dm === '58' || scope.row.dm === '60' || scope.row.dm === '82'"
                                            v-model="scope.row.sl"
                                            :min="0"
                                            :precision="0"
                                            disabled
                                        />
                                        <a-input-number v-else v-model="scope.row.sl" :min="0" :precision="0" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位财务状况明细表格 -->
                        <FGCollapsiblePanel title="财务状况表">
                            <vxe-table
                                ref="itemTableCWMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataCWMX"
                                :edit-config="{
                                    trigger: 'click',
                                    mode: 'cell',
                                    showStatus: true,
                                    showIcon: false
                                }"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zfc" title="增减" width="150" align="center">
                                    <template v-slot="scope">
                                        <FGDictSelectCN dictNo="HY100204" v-model="scope.row.zfc" placeholder="" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询业务能力及创新状况明细表格 -->
                        <FGCollapsiblePanel title="业务能力及创新状况表">
                            <vxe-table
                                ref="itemTableYWCXMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataYWCXMX"
                                :edit-config="{
                                    trigger: 'click',
                                    mode: 'cell',
                                    showStatus: true,
                                    showIcon: false
                                }"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" width="150" align="center">
                                    <template v-slot="scope">
                                        <FGDictSelectCN
                                            v-if="scope.row.dm === '250' || scope.row.dm === '252'"
                                            dictNo="1101"
                                            v-model="scope.row.zfc"
                                            placeholder=""
                                        />
                                        <FGDictSelectCN
                                            v-else-if="scope.row.dm === '251'"
                                            :dictNo="is250SelectedNo ? '' : 'HY100206'"
                                            v-model="scope.row.zfc"
                                            :disabled="is250SelectedNo"
                                            placeholder=""
                                        />
                                        <!-- <FGDictSelectCN v-else-if="scope.row.dm === '251'" dictNo="HY100205" v-model="scope.row.zfc" placeholder="" /> -->
                                        <a-input-number
                                            v-else-if="scope.row.dm === '172' || scope.row.dm === '178' || scope.row.dm === '185'"
                                            v-model="scope.row.sl"
                                            :min="0"
                                            :precision="0"
                                            disabled
                                        />
                                        <a-input-number v-else v-model="scope.row.sl" :min="0" :precision="0" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位社会影响力状况明细表格 -->
                        <FGCollapsiblePanel title="社会影响力状况表">
                            <vxe-table
                                ref="itemTableSHYXLMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataSHYXLMX"
                                :edit-config="{
                                    trigger: 'click',
                                    mode: 'cell',
                                    showStatus: true,
                                    showIcon: false
                                }"
                            >
                                <!-- <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column> -->
                                <vxe-table-column field="zbmc" title="指标名称" width="400">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbmc }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="jldw" title="计量单位" width="120" align="center"></vxe-table-column>
                                <!-- <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column> -->
                                <vxe-table-column field="sl" title="数量" mini-width="150" align="center">
                                    <template v-slot="scope">
                                        <!-- <a-input v-if="scope.row.dm === '256'" v-model="scope.row.zfc" :maxLength="200" /> -->
                                        <a-textarea
                                            v-if="scope.row.dm === '256'"
                                            v-model="scope.row.zfc"
                                            :maxLength="200"
                                            :auto-size="{
                                                minRows: 3,
                                                maxRows: 6
                                            }"
                                            style="width: 400px; min-height: 64px; resize: vertical;"
                                        />
                                        <a-input-number
                                            v-else-if="scope.row.dm === '191' || scope.row.dm === '194' || scope.row.dm === '201' || scope.row.dm === '205'"
                                            v-model="scope.row.sl"
                                            :min="0"
                                            :precision="0"
                                            :up-down-buttons="false"
                                            disabled
                                        />
                                        <a-input-number v-else v-model="scope.row.sl" :min="0" :precision="0" :up-down-buttons="false" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zbsm" title="指标说明" min-width="300">
                                    <template v-slot="{ row }">
                                        <span style="white-space: pre;">{{ row.zbsm }}</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 工程咨询单位排名申报表明细表格 -->
                        <!-- <FGCollapsiblePanel title="排名申报表">
                            <vxe-table
                                ref="itemTablePMMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataPMMX"
                            >
                                <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="mc" title="名称" min-width="200"></vxe-table-column>
                                <vxe-table-column field="sfsb" title="是否申报" width="200" align="center"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel> -->
                        <!-- 工程咨询单位业务发展判断明细表格 -->
                        <!-- <FGCollapsiblePanel title="业务发展判断表">
                            <vxe-table
                                ref="itemTableYWFZPDMX"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                show-overflow="tooltip"
                                :data="editItemDataYWFZPDMX"
                            >
                                <vxe-table-column type="seq" title="序号" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="dm" title="代码" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="mc" title="名称" min-width="200"></vxe-table-column>
                                <vxe-table-colgroup title="状态">
                                    <vxe-table-column field="yjdzt" title="2022年一季度" width="150" align="center"></vxe-table-column>
                                    <vxe-table-column field="ejdzt" title="2022年二季度" width="150" align="center"></vxe-table-column>
                                    <vxe-table-column field="sjdzt" title="2022年三季度" width="150" align="center"></vxe-table-column>
                                    <vxe-table-column field="fjdzt" title="2022年四季度" width="150" align="center"></vxe-table-column>
                                </vxe-table-colgroup>
                            </vxe-table>
                        </FGCollapsiblePanel> -->
                    </a-spin>
                    <!-- 操作日志 -->
                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "YwfzqkdjEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 明细数据
            editItemData: [],
            editItemDataLoading: false,
            // 人员明细数据
            editItemDataRYMX: [],
            editItemDataRYMXLoading: false,
            // 业务明细数据
            editItemDataYWMX: [],
            editItemDataYWMXLoading: false,
            // 财务明细数据
            editItemDataCWMX: [],
            editItemDataCWMXLoading: false,
            // 业务能力及创新明细数据
            editItemDataYWCXMX: [],
            editItemDataYWCXMXLoading: false,
            // 社会影响力明细数据
            editItemDataSHYXLMX: [],
            editItemDataSHYXLMXLoading: false,
            // 排名申报明细数据
            editItemDataPMMX: [],
            editItemDataPMMXLoading: false,
            // 业务发展判断明细数据
            editItemDataYWFZPDMX: [],
            editItemDataYWFZPDMXLoading: false,
            isShow_zymc: false,
            isShow_gzxz: false,
            isShow_sfss: false,
            isShow_pppzxyw: false,
            isShow_jyzxyw: false,
            isShow_ydylzxyw: false,
            isShow_gczxxmhj: false,
            isShow_cyzdbzgf: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            isShow_qymc: false,
            headers: {}
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "HY_YWFZQK",
                fkfield: "ID",
                attachsource: "HY1002",
                fkvalue: this.editData.id,
                isShowFolder: false
            };
        },
        // 计算属性：自动判断250是否选了"否"
        is250SelectedNo() {
            const row250 = this.editItemDataYWCXMX.find((item) => item.dm === "250");
            if (!row250) return false;

            // 假设"否"
            return row250.zfc === "否";
        }
    },
    created() {
        this.headers.Authorization = `Bearer ` + this.getToken;
    },
    watch: {
        "editData.gzxz": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "已改制") {
                        this.isShow_gzxz = true;
                    } else {
                        this.isShow_gzxz = false;
                    }
                }
            }
        },
        "editData.sfss": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_sfss = true;
                    } else {
                        this.isShow_sfss = false;
                    }
                }
            }
        },
        "editData.pppzxyw": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_pppzxyw = true;
                    } else {
                        this.isShow_pppzxyw = false;
                    }
                }
            }
        },
        "editData.jyzxyw": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_jyzxyw = true;
                    } else {
                        this.isShow_jyzxyw = false;
                    }
                }
            }
        },
        "editData.ydylzxyw": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_ydylzxyw = true;
                    } else {
                        this.isShow_ydylzxyw = false;
                    }
                }
            }
        },
        "editData.gczxxmhj": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_gczxxmhj = true;
                    } else {
                        this.isShow_gczxxmhj = false;
                    }
                }
            }
        },
        "editData.cyzdbzgf": function(val, oldval) {
            if (val !== undefined) {
                if (val !== oldval) {
                    if (val === "是") {
                        this.isShow_cyzdbzgf = true;
                    } else {
                        this.isShow_cyzdbzgf = false;
                    }
                }
            }
        },
        editItemDataRYMX: {
            handler(newVal) {
                // 高学历人员合计
                if (newVal && (newVal[8] || newVal[9])) {
                    this.updateRYMXTotal();
                }
            },
            deep: true,
            immediate: true
        },
        editItemDataYWMX: {
            handler(newVal) {
                //营业收入
                if (newVal && (newVal[1] || newVal[32] || newVal[33])) {
                    this.updateYWMXTotal();
                }
                //其中：按专业分类
                // 检查 3-23 索引中是否有值
                const hasChange = newVal && newVal.some((item, index) => index >= 3 && index <= 23 && item);
                if (hasChange) {
                    this.updateYWMXTotal1();
                }
                //其中：按服务范围分类
                // 检查 25-29 索引中是否有值
                const hasChange1 = newVal && newVal.some((item, index) => index >= 25 && index <= 29 && item);
                if (hasChange1) {
                    this.updateYWMXTotal2();
                }
            },
            deep: true,
            immediate: true
        },
        editItemDataYWCXMX: {
            handler(newVal) {
                // 承担政府委托项目（课题）数
                if (newVal && (newVal[3] || newVal[4] || newVal[5])) {
                    this.updateYWCXMXTotal();
                }
                // 研究成果类
                if (newVal && (newVal[7] || newVal[8])) {
                    this.updateYWCXMXTotal1();
                }
                // 工程咨询类业务获得奖励
                if (newVal && (newVal[10] || newVal[11] || newVal[12] || newVal[13] || newVal[14])) {
                    this.updateYWCXMXTotal2();
                }
            },
            deep: true,
            immediate: true
        },
        editItemDataSHYXLMX: {
            handler(newVal) {
                // 项目成果各级政府采用数
                if (newVal && (newVal[1] || newVal[2])) {
                    this.updateTotal();
                }
            },
            deep: true,
            immediate: true
        },
        is250SelectedNo: {
            handler(newVal) {
                // 监听状态变化，当变成"否"时，清空251的值
                const row251 = this.editItemDataYWCXMX.find((item) => item.dm === "251");
                if (newVal && row251) {
                    this.$set(row251, "zfc", "--"); // 清空选中值
                } else if (!newVal && row251) {
                    // 监听状态变化，当变成"是"时，设置251的值为"是"
                    this.$set(row251, "zfc", null);
                }
            },
            deep: true,
            immediate: true
        }
    },
    activated() {
        // 使用 $nextTick 确保响应式数据已更新，避免编辑时误判为新增
        this.$nextTick(() => {
            if (!this.editDataId) {
                // 新增模式，先清空编辑数据
                this.editData = {};
                this.editDataLoading = true;
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/selectDwxxByYhid",
                        {
                            yhid: this.getUserInfo.id
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data, errMsg }) => {
                        if (success) {
                            if (data.data) {
                                // 设置当前编辑数据
                                // this.editData = data.data;
                                // 新增，设置默认值
                                this.editData = {
                                    id: this.$FG_util.uuid(),
                                    isnew: true,
                                    djlxid: "YWFZQK",
                                    djbh: "",
                                    tbnf: this.$FG_util.formatDate(new Date(), "YYYY") - 1,
                                    djrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                                    dwid: data.data.id,
                                    dwbh: data.data.dwbh,
                                    dwmc: data.data.dwmc,
                                    dwlx: data.data.dwlx,
                                    dwlb: data.data.dwlb,
                                    dwwz: data.data.wz,
                                    frdb: data.data.frdb,
                                    zczj: data.data.zczj,
                                    txdz: data.data.txdz,
                                    tyshxydm: data.data.tyshxydm,
                                    babh: data.data.babh,
                                    cckzzxsj: data.data.cckzzxsj,
                                    zxdj: data.data.zxdj,
                                    jjzhzxqk: data.data.jjzhzxqk,
                                    bzmc: "人民币",
                                    qyid: data.data.qyid,
                                    qybh: data.data.qybh,
                                    qymc: data.data.qymc,
                                    xdwmc: data.data.dwmc,
                                    lxr: data.data.lxr,
                                    gddh: data.data.gddh,
                                    yddh: data.data.yddh,
                                    dzyx: data.data.dzyx,
                                    dwxz: data.data.dwxz,
                                    ylxr: data.data.lxr,
                                    ygddh: data.data.gddh,
                                    yyddh: data.data.yddh,
                                    ydzyx: data.data.dzyx,
                                    ydwxz: data.data.dwxz,
                                    ppp_xms: 0,
                                    ppp_hte: 0.0,
                                    jy_xms: 0,
                                    jy_hte: 0,
                                    ydyl_xms: 0,
                                    ydyl_hte: 0,
                                    hjs: 0,
                                    gjjxs: 0,
                                    sbjxs: 0,
                                    sjxs: 0,
                                    zdbzgfsl: 0,
                                    cyrysl: data.data.zgzrs,
                                    zyjsrs: data.data.zyjsrs,
                                    gjzcrs: data.data.gjzcrs,
                                    zjzcrs: data.data.zjzcrs,
                                    zczyrs: data.data.zczxsrs,
                                    ycyrysl: data.data.zgzrs,
                                    yzyjsrs: data.data.zyjsrs,
                                    ygjzcrs: data.data.gjzcrs,
                                    yzjzcrs: data.data.zjzcrs,
                                    yzczyrs: data.data.zczxsrs,
                                    ghzx_htsl: 0,
                                    ghzx_hte: 0,
                                    xmzx_htsl: 0,
                                    xmzx_hte: 0,
                                    pgzx_htsl: 0,
                                    pgzx_hte: 0,
                                    qgczx_htsl: 0,
                                    qgczx_hte: 0,
                                    ghzx_yysr: 0,
                                    ghzx_qnlr: 0,
                                    xmzx_yysr: 0,
                                    xmzx_qnlr: 0,
                                    pgzx_yysr: 0,
                                    pgzx_qnlr: 0,
                                    qgczx_yysr: 0,
                                    qgczx_qnlr: 0,
                                    bmid: this.getUserInfo.org_id,
                                    yhid: this.getUserInfo.id,
                                    ryid: this.getUserInfo.personnel_id,
                                    lrbmmc: this.getUserInfo.org_name,
                                    lrr: this.getUserInfo.personnel_name,
                                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                                    djzt: "制定"
                                };
                                this.$FG_helper.handleNewBillCode("DWQK").then((val) => {
                                    this.editData.djbh = val;
                                });
                                this.editItemData = [];
                                this.editItemDataRYMX = [];
                                this.editItemDataYWMX = [];
                                this.editItemDataCWMX = [];
                                this.editItemDataYWCXMX = [];
                                this.editItemDataSHYXLMX = [];
                                // 等待所有模板数据加载完成后再设置editDataLoading为false
                                Promise.all([
                                    this.loadItemDataRYMXMBPromise(),
                                    this.loadItemDataYWMXMBPromise(),
                                    this.loadItemDataCWMXMBPromise(),
                                    this.loadItemDataYWCXMXMBPromise(),
                                    this.loadItemDataSHYXLMXMBPromise()
                                ])
                                    .then(() => {
                                        this.editDataLoading = false;
                                        // 设置光标位置
                                        this.$nextTick(() => {
                                            this.$refs.xdwmc.focus();
                                        });
                                    })
                                    .catch(() => {
                                        // 模板数据加载失败不影响新增操作，但仍需设置editDataLoading为false
                                        this.editDataLoading = false;
                                        // 设置光标位置
                                        this.$nextTick(() => {
                                            this.$refs.xdwmc.focus();
                                        });
                                    });
                            } else {
                                this.editDataLoading = false;
                                // 加载的数据不存在则提示错误并关闭编辑窗口
                                this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                            }
                        } else {
                            this.editDataLoading = false;
                            // 加载数据出错或没有加载到数据则关闭弹窗
                            this.editIsVisible = false;
                        }
                    });
            } else {
                // 修改，加载数据
                this.loadData();
            }
        });
    },
    methods: {
        handle250Change(val) {
            const selectedValue = typeof val === "object" ? val.value : val;
            // 判断是否选择了"否"
            this.is250SelectedNo = selectedValue === "否";
            const row251 = this.editItemDataYWCXMX.find((item) => item.dm === "251");
            // 如果选了"否"，清空251行之前的选中值
            if (this.is250SelectedNo) {
                this.$set(row251, "zfc", "--");
            } else {
                // 如果选了"是"，清空251行之后的选中值
                this.$set(row251, "zfc", "");
            }
        },

        saveEvent_qymc(val, editData) {
            if (val && val.length > 0) {
                this.editData.qyid = val[0][0].ID;
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
            }
        },
        updateRYMXTotal() {
            if (!this.editItemDataRYMX || this.editItemDataRYMX.length < 10) return;
            const row9 = this.editItemDataRYMX[8];
            const row10 = this.editItemDataRYMX[9];
            const total = (row9?.sl || 0) + (row10?.sl || 0);
            if (this.editItemDataRYMX[7]) {
                this.$set(this.editItemDataRYMX[7], "sl", total);
            }
        },
        updateYWMXTotal() {
            if (!this.editItemDataYWMX || this.editItemDataYWMX.length < 34) return;
            const row2 = this.editItemDataYWMX[1];
            const row33 = this.editItemDataYWMX[32];
            const row34 = this.editItemDataYWMX[33];
            const total = (row2?.sl || 0) + (row33?.sl || 0) + (row34?.sl || 0);
            if (this.editItemDataYWMX[0]) {
                this.$set(this.editItemDataYWMX[0], "sl", total);
            }
        },
        updateYWMXTotal1() {
            if (!this.editItemDataYWMX || this.editItemDataYWMX.length < 24) return;
            let total = 0;
            // 遍历 3-23 索引，累加 sl 值
            for (let i = 3; i <= 23; i++) {
                const row = this.editItemDataYWMX[i];
                if (row && row.sl !== undefined) {
                    total += row.sl || 0;
                }
            }
            if (this.editItemDataYWMX[2]) {
                this.$set(this.editItemDataYWMX[2], "sl", total);
            }
        },
        updateYWMXTotal2() {
            if (!this.editItemDataYWMX || this.editItemDataYWMX.length < 30) return;
            let total = 0;
            for (let i = 25; i <= 29; i++) {
                const row = this.editItemDataYWMX[i];
                if (row && row.sl !== undefined) {
                    total += row.sl || 0;
                }
            }
            if (this.editItemDataYWMX[24]) {
                this.$set(this.editItemDataYWMX[24], "sl", total);
            }
        },
        updateYWCXMXTotal() {
            if (!this.editItemDataYWCXMX || this.editItemDataYWCXMX.length < 6) return;
            const row4 = this.editItemDataYWCXMX[3];
            const row5 = this.editItemDataYWCXMX[4];
            const row6 = this.editItemDataYWCXMX[5];
            const total = (row4?.sl || 0) + (row5?.sl || 0) + (row6?.sl || 0);
            if (this.editItemDataYWCXMX[2]) {
                this.$set(this.editItemDataYWCXMX[2], "sl", total);
            }
        },
        updateYWCXMXTotal1() {
            if (!this.editItemDataYWCXMX || this.editItemDataYWCXMX.length < 9) return;
            const row10 = this.editItemDataYWCXMX[7];
            const row11 = this.editItemDataYWCXMX[8];
            const total = (row10?.sl || 0) + (row11?.sl || 0);
            if (this.editItemDataYWCXMX[6]) {
                this.$set(this.editItemDataYWCXMX[6], "sl", total);
            }
        },
        updateYWCXMXTotal2() {
            if (!this.editItemDataYWCXMX || this.editItemDataYWCXMX.length < 18) return;
            const row13 = this.editItemDataYWCXMX[10];
            const row14 = this.editItemDataYWCXMX[11];
            const row15 = this.editItemDataYWCXMX[12];
            const row16 = this.editItemDataYWCXMX[13];
            const row17 = this.editItemDataYWCXMX[14];
            const total = (row13?.sl || 0) + (row14?.sl || 0) + (row15?.sl || 0) + (row16?.sl || 0) + (row17?.sl || 0);
            if (this.editItemDataYWCXMX[9]) {
                this.$set(this.editItemDataYWCXMX[9], "sl", total);
            }
        },
        updateTotal() {
            if (!this.editItemDataSHYXLMX || this.editItemDataSHYXLMX.length < 3) return;
            const row2 = this.editItemDataSHYXLMX[1];
            const row3 = this.editItemDataSHYXLMX[2];
            const total = (row2?.sl || 0) + (row3?.sl || 0);
            if (this.editItemDataSHYXLMX[0]) {
                this.$set(this.editItemDataSHYXLMX[0], "sl", total);
            }
        },
        search_zymc(row) {
            this.isShow_zymc = true;
            this.select_zymc = row;
        },
        saveEvent_zymc(val, currentrow) {
            if (val && val.length > 0) {
                this.select_zymc.zyid = val[0][0].ID;
                this.select_zymc.zymc = val[0][0].ZYMC;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editItemData = [];
            this.editItemDataRYMX = [];
            this.editItemDataYWMX = [];
            this.editItemDataCWMX = [];
            this.editItemDataYWCXMX = [];
            this.editItemDataSHYXLMX = [];
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 使用Promise.all等待所有明细表数据加载完成
                            Promise.all([
                                this.loadItemDataPromise(),
                                this.loadItemDataRYMXPromise(),
                                this.loadItemDataYWMXPromise(),
                                this.loadItemDataCWMXPromise(),
                                this.loadItemDataYWCXMXPromise(),
                                this.loadItemDataSHYXLMXPromise()
                            ])
                                .then(() => {
                                    this.editDataLoading = false;
                                    this.initOperLog();
                                })
                                .catch(() => {
                                    this.editDataLoading = false;
                                    this.editIsVisible = false;
                                });
                        } else {
                            this.editDataLoading = false;
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        this.editDataLoading = false;
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载明细表数据（Promise版本）
        loadItemDataPromise() {
            return new Promise((resolve) => {
                this.editItemData = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listMX",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemData = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载人员情况明细表数据（Promise版本）
        loadItemDataRYMXPromise() {
            return new Promise((resolve) => {
                this.editItemDataRYMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listRYMX",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataRYMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载业务情况明细表数据（Promise版本）
        loadItemDataYWMXPromise() {
            return new Promise((resolve) => {
                this.editItemDataYWMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listYWMX",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataYWMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载财务情况明细表数据（Promise版本）
        loadItemDataCWMXPromise() {
            return new Promise((resolve) => {
                this.editItemDataCWMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listCWMX",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataCWMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载业务创新明细表数据（Promise版本）
        loadItemDataYWCXMXPromise() {
            return new Promise((resolve) => {
                this.editItemDataYWCXMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listYWCXMX",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataYWCXMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载社会影响力明细表数据（Promise版本）
        loadItemDataSHYXLMXPromise() {
            return new Promise((resolve) => {
                this.editItemDataSHYXLMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listSHYXLMX",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataSHYXLMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载人员情况明细表数据-模板（Promise版本）
        loadItemDataRYMXMBPromise() {
            return new Promise((resolve) => {
                this.editItemDataRYMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listRYMXMB",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataRYMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载业务情况明细表数据-模板（Promise版本）
        loadItemDataYWMXMBPromise() {
            return new Promise((resolve) => {
                this.editItemDataYWMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listYWMXMB",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataYWMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载财务情况明细表数据-模板（Promise版本）
        loadItemDataCWMXMBPromise() {
            return new Promise((resolve) => {
                this.editItemDataCWMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listCWMXMB",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataCWMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载业务创新明细表数据-模板（Promise版本）
        loadItemDataYWCXMXMBPromise() {
            return new Promise((resolve) => {
                this.editItemDataYWCXMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listYWCXMXMB",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataYWCXMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载社会影响力明细表数据-模板（Promise版本）
        loadItemDataSHYXLMXMBPromise() {
            return new Promise((resolve) => {
                this.editItemDataSHYXLMX = [];
                this.$FG_http
                    .post(
                        "./api/main/hydcgl/hydc/listSHYXLMXMB",
                        {
                            djid: this.dataId,
                            sort: {
                                field: "XH",
                                order: "asc"
                            }
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data }) => {
                        if (success) {
                            this.editItemDataSHYXLMX = data.data || [];
                        }
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
        // 加载明细表数据
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载人员情况明细表数据
        loadItemDataRYMX() {
            this.editItemDataRYMX = [];
            this.editItemDataRYMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listRYMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataRYMXLoading = false;
                    if (success) {
                        this.editItemDataRYMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载人员情况明细表数据-模板
        loadItemDataRYMXMB() {
            this.editItemDataRYMX = [];
            this.editItemDataRYMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listRYMXMB",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataRYMXLoading = false;
                    if (success) {
                        this.editItemDataRYMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务情况表明细表数据
        loadItemDataYWMX() {
            this.editItemDataYWMX = [];
            this.editItemDataYWMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWMXLoading = false;
                    if (success) {
                        this.editItemDataYWMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务情况表明细表数据-模板
        loadItemDataYWMXMB() {
            this.editItemDataYWMX = [];
            this.editItemDataYWMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWMXMB",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWMXLoading = false;
                    if (success) {
                        this.editItemDataYWMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载财务明细表数据
        loadItemDataCWMX() {
            this.editItemDataCWMX = [];
            this.editItemDataCWMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listCWMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataCWMXLoading = false;
                    if (success) {
                        this.editItemDataCWMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载财务明细表数据-模板
        loadItemDataCWMXMB() {
            this.editItemDataCWMX = [];
            this.editItemDataCWMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listCWMXMB",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataCWMXLoading = false;
                    if (success) {
                        this.editItemDataCWMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务能力及创新状况明细表数据
        loadItemDataYWCXMX() {
            this.editItemDataYWCXMX = [];
            this.editItemDataYWCXMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWCXMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWCXMXLoading = false;
                    if (success) {
                        this.editItemDataYWCXMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务能力及创新状况明细表数据-模板
        loadItemDataYWCXMXMB() {
            this.editItemDataYWCXMX = [];
            this.editItemDataYWCXMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWCXMXMB",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWCXMXLoading = false;
                    if (success) {
                        this.editItemDataYWCXMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载社会影响力明细表数据
        loadItemDataSHYXLMX() {
            this.editItemDataSHYXLMX = [];
            this.editItemDataSHYXLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listSHYXLMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataSHYXLMXLoading = false;
                    if (success) {
                        this.editItemDataSHYXLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载社会影响力明细表数据-模板
        loadItemDataSHYXLMXMB() {
            this.editItemDataSHYXLMX = [];
            this.editItemDataSHYXLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listSHYXLMXMB",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataSHYXLMXLoading = false;
                    if (success) {
                        this.editItemDataSHYXLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载排名申报明细表数据
        loadItemDataPMMX() {
            this.editItemDataPMMX = [];
            this.editItemDataPMMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listPMMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataPMMXLoading = false;
                    if (success) {
                        this.editItemDataPMMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载业务发展判断明细表数据
        loadItemDataYWFZPDMX() {
            this.editItemDataYWFZPDMX = [];
            this.editItemDataYWFZPDMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/listYWFZPDMX",
                    {
                        djid: this.dataId,
                        sort: {
                            field: "XH ",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYWFZPDMXLoading = false;
                    if (success) {
                        this.editItemDataYWFZPDMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增明细
        insertItem() {
            // 设置编辑记录
            this.$refs.itemTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        djid: this.editData.id,
                        xms: 0,
                        xmztze: 0
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemTable.setActiveRow(row);
                });
        },
        // 删除明细
        removeItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/hydcgl/hydc/deleteMX", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadData(row.id);
                                    this.loadItemData();
                                }
                            });
                    }
                }
            });
        },
        //提交form
        onSave(btnType) {
            // 获取变化的数据 - 使用深拷贝避免异步操作中数据被修改
            let itemData = JSON.parse(JSON.stringify(this.$refs.itemTable?.getTableData?.()?.tableData || []));
            let itemRemovedData = [];
            //人员情况表
            const rymxData = JSON.parse(JSON.stringify(this.$refs.itemTableRYMX?.getTableData?.()?.tableData || []));
            //业务状况表
            const ywmxData = JSON.parse(JSON.stringify(this.$refs.itemTableYWMX?.getTableData?.()?.tableData || []));
            //财务状况表
            const cwmxData = JSON.parse(JSON.stringify(this.$refs.itemTableCWMX?.getTableData?.()?.tableData || []));
            //业务能力及创新状况表
            const ywcxmxData = JSON.parse(JSON.stringify(this.$refs.itemTableYWCXMX?.getTableData?.()?.tableData || []));
            //社会影响力状况表
            const shyxlmxData = JSON.parse(JSON.stringify(this.$refs.itemTableSHYXLMX?.getTableData?.()?.tableData || []));

            if (btnType === 1) {
                // 表单校验
                if (!this.editData.tyshxydm) {
                    this.$FG_message.error("P0001", "统一社会信用代码").then(() => this.$refs.tyshxydm.focus());
                    return;
                }
                if (!this.editData.dwclsj) {
                    this.$FG_message.error("P0001", "单位成立时间").then(() => this.$refs.dwclsj.focus());
                    return;
                }
                if (!this.editData.frdb) {
                    this.$FG_message.error("P0001", "法定代表人").then(() => this.$refs.frdb.focus());
                    return;
                }
                if (!this.editData.bzmc) {
                    this.$FG_message.error("P0001", "币种").then(() => this.$refs.bzmc.focus());
                    return;
                }

                if (!this.editData.lxr) {
                    this.$FG_message.error("P0001", "联系人姓名").then(() => this.$refs.lxr.focus());
                    return;
                }
                if (!this.editData.gddh) {
                    this.$FG_message.error("P0001", "联系人固定电话").then(() => this.$refs.gddh.focus());
                    return;
                }
                if (!this.editData.yddh) {
                    this.$FG_message.error("P0001", "联系人手机号").then(() => this.$refs.yddh.focus());
                    return;
                }
                if (!this.editData.dzyx) {
                    this.$FG_message.error("P0001", "联系人电子邮箱").then(() => this.$refs.dzyx.focus());
                    return;
                }
                if (!this.editData.babh) {
                    this.$FG_message.error("P0001", "备案编号").then(() => this.$refs.babh.focus());
                    return;
                }
                if (!this.editData.dwxz) {
                    this.$FG_message.error("P0001", "单位类型").then(() => this.$refs.dwxz.focus());
                    return;
                }
                if (!this.editData.sfss) {
                    this.$FG_message.error("P0001", "是否上市").then(() => this.$refs.sfss.focus());
                    return;
                }
                if (!this.editData.ysgm) {
                    this.$FG_message.error("P0001", "营收规模").then(() => this.$refs.ysgm.focus());
                    return;
                }
                if (!this.editData.gczxysgm) {
                    this.$FG_message.error("P0001", "其中工程咨询营收规模").then(() => this.$refs.gczxysgm.focus());
                    return;
                }

                if (!this.editData.txdz) {
                    this.$FG_message.error("P0001", "通讯地址").then(() => this.$refs.txdz.focus());
                    return;
                }
                if (!this.editData.qymc) {
                    this.$FG_message.error("P0001", "所在城市").then(() => this.$refs.qymc.focus());
                    return;
                }
                if (!this.editData.cckzzxsj) {
                    this.$FG_message.error("P0001", "初次开展工程咨询年份").then(() => this.$refs.cckzzxsj.focus());
                    return;
                }
                if (!this.editData.zxdj) {
                    this.$FG_message.error("P0001", "工程咨询单位资信等级").then(() => this.$refs.zxdj.focus());
                    return;
                }
                if (!this.editData.jjzhzxqk) {
                    this.$FG_message.error("P0001", "甲级综合资信情况").then(() => this.$refs.jjzhzxqk.focus());
                    return;
                }
                if (this.editData.jjzyzxgs === null || this.editData.jjzyzxgs === undefined) {
                    this.$FG_message.error("P0001", "甲级专业资信个数").then(() => this.$refs.jjzyzxgs.focus());
                    return;
                }
                if (this.editData.yjzyzxgs === null || this.editData.yjzyzxgs === undefined) {
                    this.$FG_message.error("P0001", "乙级专业资信个数").then(() => this.$refs.yjzyzxgs.focus());
                    return;
                }
                if (this.editData.pppzxzxzxqk === null || this.editData.pppzxzxzxqk === undefined) {
                    this.$FG_message.error("P0001", "PPP咨询专项资信个数").then(() => this.$refs.pppzxzxzxqk.focus());
                    return;
                }
                if (!this.editData.gckczz) {
                    this.$FG_message.error("P0001", "工程勘察资质").then(() => this.$refs.gckczz.focus());
                    return;
                }
                if (!this.editData.gcsjzz) {
                    this.$FG_message.error("P0001", "工程设计资质").then(() => this.$refs.gcsjzz.focus());
                    return;
                }
                if (!this.editData.gcjlzz) {
                    this.$FG_message.error("P0001", "工程监理资质").then(() => this.$refs.gcjlzz.focus());
                    return;
                }
                if (!this.editData.dwcbgczg) {
                    this.$FG_message.error("P0001", "对外承包工程资格").then(() => this.$refs.dwcbgczg.focus());
                    return;
                }
                if (!this.editData.bmzz) {
                    this.$FG_message.error("P0001", "保密资质").then(() => this.$refs.bmzz.focus());
                    return;
                }

                let emptyIndex = rymxData.findIndex((item) => {
                    return item.sl === null || item.sl === undefined || item.sl === "";
                });
                if (emptyIndex !== -1) {
                    const zbmc = "人员情况表 " + rymxData[emptyIndex].zbmc;
                    this.$FG_message.error("P0001", zbmc);
                    return;
                }

                emptyIndex = ywmxData.findIndex((item) => {
                    return item.sl === null || item.sl === undefined || item.sl === "";
                });
                if (emptyIndex !== -1) {
                    const zbmc = "业务状况表 " + ywmxData[emptyIndex].zbmc;
                    this.$FG_message.error("P0001", zbmc);
                    return;
                }

                emptyIndex = cwmxData.findIndex((item) => {
                    return item.zfc === null || item.zfc === undefined || item.zfc === "";
                });
                if (emptyIndex !== -1) {
                    const zbmc = "财务状况表 " + cwmxData[emptyIndex].zbmc;
                    this.$FG_message.error("P0001", zbmc);
                    return;
                }

                emptyIndex = ywcxmxData.findIndex((item) => {
                    if (item.dm === "250" || item.dm === "251" || item.dm === "252") {
                        return item.zfc === null || item.zfc === undefined || item.zfc === "";
                    } else {
                        return item.sl === null || item.sl === undefined || item.sl === "";
                    }
                });
                if (emptyIndex !== -1) {
                    const zbmc = "业务能力及创新状况表 " + ywcxmxData[emptyIndex].zbmc;
                    this.$FG_message.error("P0001", zbmc);
                    return;
                }

                emptyIndex = shyxlmxData.findIndex((item) => {
                    if (item.dm === "256") {
                        return item.zfc === null || item.zfc === undefined || item.zfc === "";
                    } else if (item.dm !== "194" && item.dm !== "201" && item.dm !== "205") {
                        return item.sl === null || item.sl === undefined || item.sl === "";
                    }
                });
                if (emptyIndex !== -1) {
                    const zbmc = "社会影响力状况表 " + shyxlmxData[emptyIndex].zbmc;
                    this.$FG_message.error("P0001", zbmc);
                    return;
                }
            }

            // 保存操作
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/hydcgl/hydc/save",
                    {
                        data: this.editData,
                        itemData,
                        itemRemovedData,
                        rymxData,
                        ywmxData,
                        cwmxData,
                        ywcxmxData,
                        shyxlmxData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        this.loadItemData();
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.xdwmc.focus();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
            // 重置编辑数据ID，避免影响下次操作
            this.editDataId = null;
        },
        //提交
        submit(lx) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/hydcgl/hydc/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                //提交之后跳转主页面
                                this.editIsVisible = false;
                            } else {
                                this.$refs.xdwmc.focus();
                            }
                        });
                }
            });
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        },
        uploadSafeEvent(info) {
            if (info.file.status === "done") {
                if (info.file.response.success) {
                    this.$message.success("文件导入成功");
                    this.dataId = this.editData.id;
                    this.loadData();
                } else {
                    this.$message.error(info.file.response.message);
                }
            } else if (info.file.status === "error") {
                this.$message.error(`${info.file.name} 文件导入失败`);
            }
        }
    }
};
</script>
<style scoped>
:deep(.vxe-table--render-default.size--mini.vxe-body--column.col--ellipsis > .vxe-cell) {
    max-height: none !important;
    white-space: pre-wrap;
    word-break: break-all;
}
:deep(.vxe-table--render-default.size--mini .vxe-body--column > .vxe-cell) {
    white-space: pre-wrap;
    word-break: break-all;
}
/* 完全隐藏数字输入框的上下箭头 */
:deep(.ant-input-number-handler-wrap) {
    display: none !important;
}
/* :deep(.vxe-table--render-default .vxe-body--column .a-textarea) {
    width: 400px !important;
    min-height: 80px;
    resize: vertical;
} */
</style>
